function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { Banner, withSnackbar } from "@dpdgroupuk/mydpd-ui";
import { BANNERS_TYPES, PRINTER_TYPE, PRINTER_DRIVER_TYPE } from "@dpdgroupuk/mydpd-enums";
import { Context } from "../Local";
import { withUrlResolver } from "../../Context";
import { UrlResolverPropType } from "../../PropTypes";
import PrinterError from "./PrinterError";
import { M } from "../../constants";

class PrinterConfigurator extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "showConfigurePrinterBanner", ({
      error
    }) => {
      const {
        banner,
        snackbar
      } = this.props;
      const {
        settingsBannerId
      } = this.state;
      settingsBannerId && banner.hideById(settingsBannerId);
      const bannerData = {
        message: error.name === "PrinterError" ? error.message : M.$_IS_NOT_CONFIGURED("Thermal Printer"),
        closable: false,
        showIcon: true,
        actions: []
      };

      if (error.code === PrinterError.STATUS_CODE.WEB_USB_NOT_PAIRED) {
        bannerData.actions.push({
          text: M.PAIR,
          handleClick: async () => {
            try {
              // pair device
              await this.context.printer.driver.pairDevice(); // configure again to check if there are no more errors

              await this.context.printer.configure(this.props.initialConfig);
              this.hideBanner();
            } catch (e) {
              snackbar.showAlert({
                message: e.message
              });
            }
          }
        });
      }

      bannerData.actions.push({
        text: M.RE_CONFIGURE,
        href: this.props.urlResolver.getUrl("mydpd.account.printing-settings"),
        target: "self"
      });
      bannerData.actions.push({
        text: M.REFRESH_STATUS,
        handleClick: () => {
          this.context.printer.configure(this.props.initialConfig);
        }
      });
      const newBannerId = banner.showByType(BANNERS_TYPES.ALERT, bannerData);
      this.setState({
        settingsBannerId: newBannerId
      });
    });

    this.state = {
      settingsBannerId: null
    };
  }

  componentDidMount() {
    this.printerReadyListener = this.context.printer.addListener("printer-ready", ({
      detail
    }) => {
      this.hideBanner();
    });
    this.printerFailListener = this.context.printer.addListener("printer-fail", ({
      detail
    }) => {
      this.showConfigurePrinterBanner(detail);
    });
    this.context.printer.configure(this.props.initialConfig);
  }

  hideBanner() {
    this.state.settingsBannerId && this.props.banner.hideById(this.state.settingsBannerId);
  }

  componentWillUnmount() {
    this.hideBanner();
    this.printerReadyListener && this.printerReadyListener();
    this.printerFailListener && this.printerFailListener();
  }

  render() {
    return null;
  }

}

_defineProperty(PrinterConfigurator, "contextType", Context);

PrinterConfigurator.defaultProps = {
  initialConfig: {
    printToThermal: false,
    thermalPrinterName: null,
    thermalPrinterPort: null,
    thermalPrinterType: null,
    thermalPrinterVendorId: null,
    thermalPrinterProductId: null,
    thermalPrinterDriverType: PRINTER_DRIVER_TYPE.NONE
  }
};
PrinterConfigurator.propTypes = {
  banner: PropTypes.object,
  snackbar: PropTypes.object,
  urlResolver: UrlResolverPropType,
  initialConfig: PropTypes.shape({
    printToThermal: PropTypes.bool,
    thermalPrinterName: PropTypes.string,
    thermalPrinterPort: PropTypes.string,
    thermalPrinterType: PropTypes.oneOf(Object.values(PRINTER_TYPE)),
    // new fields
    thermalPrinterVendorId: PropTypes.number,
    thermalPrinterProductId: PropTypes.number,
    thermalPrinterDriverType: PropTypes.oneOf(Object.values(PRINTER_DRIVER_TYPE))
  })
};
export default compose(Banner.withBanner, withSnackbar, withUrlResolver)(PrinterConfigurator);